import { CreditCard, Trash2 } from "lucide-react"
import { cn } from "@/lib/utils"
import type { PaymentMethod } from "../types/payment"

export interface PaymentMethodCardProps {
  method: PaymentMethod
  expiryLabel?: string
  defaultLabel?: string
  setDefaultLabel?: string
  removeAriaLabel?: string
  onSetDefault?: (method: PaymentMethod) => void
  onDelete?: (method: PaymentMethod) => void
  className?: string
}

export function PaymentMethodCard({
  method,
  expiryLabel = "Expires",
  defaultLabel = "Default",
  setDefaultLabel = "Set default",
  removeAriaLabel = "Remove payment method",
  onSetDefault,
  onDelete,
  className,
}: PaymentMethodCardProps) {
  return (
    <div
      className={cn(
        "bg-card border border-border rounded-md px-3 py-2.5 flex items-center gap-3",
        className,
      )}
    >
      <CreditCard size={16} strokeWidth={1.5} className="text-muted-foreground shrink-0" />
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-1.5">
          <span className="text-caption text-foreground font-medium truncate">
            {method.brand} •••• {method.last4}
          </span>
          {method.isDefault && (
            <span className="text-caption text-muted-foreground border border-border rounded px-1 py-0.5 shrink-0">
              {defaultLabel}
            </span>
          )}
        </div>
        <span className="text-caption text-muted-foreground">
          {expiryLabel} {method.expiry}
        </span>
      </div>
      {!method.isDefault && (
        <div className="flex items-center gap-1.5 shrink-0">
          {onSetDefault && (
            <button
              type="button"
              onClick={() => onSetDefault(method)}
              className="text-caption text-muted-foreground hover:text-foreground transition-colors cursor-pointer"
            >
              {setDefaultLabel}
            </button>
          )}
          {onDelete && (
            <button
              type="button"
              onClick={() => onDelete(method)}
              aria-label={removeAriaLabel}
              className="text-muted-foreground hover:text-destructive transition-colors cursor-pointer"
            >
              <Trash2 size={12} strokeWidth={1.5} />
            </button>
          )}
        </div>
      )}
    </div>
  )
}
